import { withTaxIdBesideYearBuilt } from '../../shared';
import type { ListingLocaleOverrides } from '../base';
import {
  buyersAttorneyContactCard,
  sellersAttorneyContactCard,
} from '../cards';

export const MAOverrides: ListingLocaleOverrides = {
  locale: 'MA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            withTaxIdBesideYearBuilt(layout).concat([
              [
                {
                  name: 'property.platbook',
                  size: 50,
                },
                {
                  name: 'property.pages',
                  size: 50,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            platbook: {
              name: 'property.platbook',
              entity: 'property',
              type: 'text',
              label: 'Book',
              placeholderText: '',
            },
            pages: {
              name: 'property.pages',
              entity: 'property',
              type: 'text',
              label: 'Page',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText: 'Copy legal description from tax records',
            },
          },
        },
      },
    },
    sellerSideContacts: {
      cards: {
        sellersAttorneyContactCard,
      },
    },
    buyerSideContacts: {
      cards: {
        buyersAttorneyContactCard,
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: null,
      },
    },
  },
};
